/*
  Kiwi Ears · worldwide events (Rene 2026-08-30) — sections/ev-*.

  IT FILTERS MARKUP, IT NEVER BUILDS AN EVENT. Every event is a customizer
  block server-rendered into a card by ev-shows; this file reads those cards
  and drives four views of the same nodes — filters, map pins, the timeline
  and the dialog — plus the hero's next-event card. All views share one data
  source: the DOM the merchandiser edits. The MAP is the exception to
  filtering (Rene 2026-08-31): it previews ALL events at all times — pins and
  pins never dim; tabs, search and chips segment the cards below only.

  DATES DECIDE THEMSELVES. The browser's date classifies each event as
  upcoming / happening now / past, so the page is correct the morning an event
  opens with nobody editing anything. Dates are parsed as LOCAL midnights, not
  Date.parse ISO (which reads bare dates as UTC and marks an event "past" a
  timezone too early), and an event is "now" through the whole of its end day.

  THE .ICS EXPORT ships the public dates only, matching the publishing rule:
  the calendar entry is about the event, not about Kiwi Ears' unconfirmed
  attendance. All-day format, DTEND exclusive per RFC 5545.

  Chips are derived from the cards, so a type or region filter can never be
  offered with nothing behind it.
*/
(function () {
  'use strict';
  if (window.__kiwiEvents) return;
  window.__kiwiEvents = true;

  var root = document.querySelector('[data-ev-root]');
  if (!root) return;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------- the data */
  function localDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3]);
  }
  var today = new Date();
  today = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  var EVENTS = $$('[data-ev-card]', root).map(function (n) {
    var start = localDate(n.getAttribute('data-start'));
    var end = localDate(n.getAttribute('data-end')) || start;
    var read = function (sel) { var el = $(sel, n); return el ? el.textContent.trim() : ''; };
    var when = 'upcoming';
    if (start && end) {
      if (end < today) when = 'past';
      else if (start <= today) when = 'now';
    }
    return {
      node: n,
      id: n.getAttribute('data-id'),
      name: n.getAttribute('data-name'),
      type: n.getAttribute('data-type'),
      typeLabel: (($('.ev-typechip', n) || {}).textContent || '').trim(),
      region: n.getAttribute('data-region'),
      regionLabel: read('[data-ev-region-label]'),
      search: n.getAttribute('data-search') || '',
      start: start, end: end, when: when,
      where: (($('.ev-cardwhere', n) || {}).textContent || '').trim(),
      dates: (($('.ev-carddates', n) || {}).textContent || '').trim(),
      focus: (($('.ev-cardfocus', n) || {}).textContent || '').trim(),
      venue: read('[data-ev-venue]'),
      booth: read('[data-ev-booth]'),
      url: read('[data-ev-url]'),
      pageUrl: read('[data-ev-pageurl]'),
      logoUrl: read('[data-ev-logourl]'),
      status: (($('.ev-status', n) || {}).textContent || '').trim(),
      confirmed: !!$('.ev-status--on', n),
      pin: $('[data-ev-pin="' + n.getAttribute('data-id') + '"]', root)
    };
  });
  if (!EVENTS.length) return;
  var BY = {};
  EVENTS.forEach(function (e) { BY[e.id] = e; });

  /* pin decluster (Rene 2026-08-31): two shows can share a metro — Tokyo and
     Chiba sat 0.1% apart and rendered as ONE marker, which reads as a missing
     event. Pins whose tips land within ~1.2% of each other fan out
     symmetrically along x (Liquid wrote the true position; this only spreads
     exact pile-ups, singletons never move). O(n²) over ≤50 pins is nothing. */
  (function () {
    var pins = $$('[data-ev-pin]', root).filter(function (p) { return p.style.left; });
    var used = {};
    var clusters = [];
    pins.forEach(function (p) {
      if (used[p.getAttribute('data-ev-pin')]) return;
      var x = parseFloat(p.style.left), y = parseFloat(p.style.top);
      var group = [p];
      pins.forEach(function (q) {
        if (q === p || used[q.getAttribute('data-ev-pin')]) return;
        if (Math.abs(parseFloat(q.style.left) - x) < 1.2 && Math.abs(parseFloat(q.style.top) - y) < 1.1) {
          group.push(q);
          used[q.getAttribute('data-ev-pin')] = true;
        }
      });
      used[p.getAttribute('data-ev-pin')] = true;
      if (group.length > 1) clusters.push(group);
    });
    clusters.forEach(function (group) {
      group.sort(function (a, b) { return parseFloat(a.style.left) - parseFloat(b.style.left); });
      var cx = group.reduce(function (s, p) { return s + parseFloat(p.style.left); }, 0) / group.length;
      group.forEach(function (p, i) {
        p.style.left = (cx + (i - (group.length - 1) / 2) * 1.3).toFixed(2) + '%';
      });
    });
  })();

  /* state badges — written once; filtering never changes what a thing is.
     The label is SPECIFIC ("In 12 days"), not categorical ("Upcoming"): the
     category is already carried by which group the card sits in, so the badge
     can spend its pixels on the fact that differs per card. Far-off dates and
     past events get no badge at all — the bold date line says enough. */
  EVENTS.forEach(function (e) {
    e.node.setAttribute('data-when', e.when);
    if (e.pin) e.pin.setAttribute('data-when', e.when);
    var el = $('[data-ev-state]', e.node);
    if (!el) return;
    var label = '';
    if (e.when === 'now') label = 'Happening now';
    else if (e.when === 'upcoming' && e.start) {
      var days = Math.round((e.start - today) / 864e5);
      if (days === 0) label = 'Today';
      else if (days === 1) label = 'Tomorrow';
      else if (days <= 60) label = 'In ' + days + ' days';
    }
    el.textContent = label;
    el.hidden = !label;
    el.setAttribute('data-when', e.when);
  });

  /* chronological order regardless of block order in the customizer — and
     the temporal split: upcoming + live stay in the main grid soonest-first,
     past events move to the archive rows most-recent-first. With JS off
     nothing moves and the server-rendered single list stands. */
  var grid = $('[data-ev-grid]', root);
  var pastGrid = $('[data-ev-grid-past]', root);
  if (grid) {
    var asc = EVENTS.slice().sort(function (a, b) { return (a.start || 0) - (b.start || 0); });
    asc.forEach(function (e) {
      if (pastGrid && e.when === 'past') return;
      grid.appendChild(e.node);
    });
    if (pastGrid) {
      asc.slice().reverse().forEach(function (e) {
        if (e.when === 'past') pastGrid.appendChild(e.node);
      });
    }
  }

  /* ------------------------------------------------------------- controls */
  var state = { q: '', type: '', region: '', when: '' };
  /* a shared ?show=past|upcoming link lands on the right tab */
  try {
    var showQ = new URL(location.href).searchParams.get('show');
    if (showQ === 'past' || showQ === 'upcoming') state.when = showQ;
  } catch (err) { /* URL API missing: default tab stands */ }

  function chip(label, value, attr, count) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ev-chip';
    b.setAttribute(attr, value);
    b.setAttribute('aria-pressed', String(value === ''));
    b.appendChild(document.createTextNode(label));
    if (count != null) {
      var s = document.createElement('span');
      s.className = 'ev-chipcount';
      s.textContent = count;
      b.appendChild(s);
    }
    return b;
  }
  var typeWrap = $('[data-ev-types]', root);
  if (typeWrap) {
    typeWrap.appendChild(chip('All events', '', 'data-ev-type', EVENTS.length));
    var seenT = {};
    EVENTS.forEach(function (e) {
      if (seenT[e.type]) { seenT[e.type].n++; return; }
      seenT[e.type] = { label: e.typeLabel || e.type, n: 1 };
    });
    Object.keys(seenT).forEach(function (t) {
      typeWrap.appendChild(chip(seenT[t].label, t, 'data-ev-type', seenT[t].n));
    });
  }
  var regionWrap = $('[data-ev-regions]', root);
  if (regionWrap) {
    regionWrap.appendChild(chip('All regions', '', 'data-ev-region'));
    var seenR = {};
    EVENTS.forEach(function (e) {
      if (!e.region || seenR[e.region]) return;
      seenR[e.region] = 1;
      regionWrap.appendChild(chip(e.regionLabel || e.region, e.region, 'data-ev-region'));
    });
  }

  var countEl = $('[data-ev-count]', root);
  var emptyEl = $('[data-ev-empty]', root);
  var clearEl = $('[data-ev-clear]', root);
  var upHead = $('[data-ev-uphead]', root);
  var pastHead = $('[data-ev-pasthead]', root);
  var upCountEl = $('[data-ev-upcount]', root);
  var pastCountEl = $('[data-ev-pastcount]', root);

  function apply() {
    var q = state.q.trim().toLowerCase();
    var shown = 0, shownUp = 0, shownPast = 0;
    EVENTS.forEach(function (e) {
      var ok = true;
      if (state.type && e.type !== state.type) ok = false;
      if (ok && state.region && e.region !== state.region) ok = false;
      /* the tabs are two-sided: "upcoming" includes happening-now, because a
         visitor asking what's coming must not lose the show that is on right
         now; "past" is exactly the archive */
      if (ok && state.when === 'past' && e.when !== 'past') ok = false;
      if (ok && state.when === 'upcoming' && e.when === 'past') ok = false;
      if (ok && q && e.search.indexOf(q) === -1) ok = false;
      e.node.hidden = !ok;
      /* the MAP is deliberately untouched here (Rene 2026-08-31): it is a
         preview of ALL events — every pin stays lit whatever the
         tabs or filters say. Segmenting is card-only. */
      if (ok) { shown++; if (e.when === 'past') shownPast++; else shownUp++; }
      /* the timeline mirrors the same verdict */
      if (e.tl) e.tl.hidden = !ok;
    });
    /* each temporal group carries its own head; an emptied group folds away */
    if (upHead) {
      upHead.hidden = shownUp === 0;
      if (upCountEl) upCountEl.textContent = shownUp + (shownUp === 1 ? ' event' : ' events');
    }
    if (pastHead) {
      pastHead.hidden = shownPast === 0;
      if (pastCountEl) pastCountEl.textContent = shownPast + (shownPast === 1 ? ' event' : ' events');
    }
    if (pastGrid) pastGrid.hidden = shownPast === 0;
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' event' : ' events');
    if (emptyEl) emptyEl.hidden = shown > 0;
    if (clearEl) clearEl.hidden = !(state.q || state.type || state.region || state.when);
    ['type', 'region', 'when'].forEach(function (k) {
      $$('[data-ev-' + k + ']', root).forEach(function (b) {
        if (!b.matches('button')) return;
        b.setAttribute('aria-pressed', String(b.getAttribute('data-ev-' + k) === state[k]));
      });
    });
  }

  /* the chosen tab rides the URL so a "past events" link can be shared */
  function syncShowParam() {
    if (!(window.history && history.replaceState)) return;
    var url = new URL(location.href);
    if (state.when) url.searchParams.set('show', state.when);
    else url.searchParams.delete('show');
    history.replaceState(null, '', url);
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var m;
    if ((m = t.closest('[data-ev-type]')) && m.matches('button')) { state.type = m.getAttribute('data-ev-type'); apply(); return; }
    if ((m = t.closest('[data-ev-region]')) && m.matches('button')) { state.region = m.getAttribute('data-ev-region'); apply(); return; }
    if ((m = t.closest('[data-ev-when]'))) { state.when = m.getAttribute('data-ev-when'); apply(); syncShowParam(); return; }
    if (t.closest('[data-ev-clear]')) {
      state = { q: '', type: '', region: '', when: '' };
      if (input) input.value = '';
      apply(); syncShowParam(); return;
    }
    if ((m = t.closest('[data-ev-pin]'))) { openEvent(m.getAttribute('data-ev-pin')); return; }
    if ((m = t.closest('[data-ev-open]'))) { openEvent(m.getAttribute('data-ev-open')); return; }
    var card = t.closest('[data-ev-card]');
    if (card && !t.closest('a')) {
      /* an event with its own hub page goes there; one without opens the
         drawer — the same split the card's own title and CTA make */
      var pu = card.getAttribute('data-page');
      if (pu) { window.location.href = pu; return; }
      openEvent(card.getAttribute('data-id')); return;
    }
    if (t.closest('[data-ev-d-close]')) { dlg.close(); return; }
    if (t.closest('[data-ev-d-ics]')) { downloadICS(); return; }
  });

  /* The hero's next-event button lives in ev-hero, OUTSIDE this section's
     root — its listener has to be document-level or the click never arrives.
     (Found the hard way: the button silently did nothing.) */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ev-next-open]')) {
      if (nextEvent) openEvent(nextEvent.id);
    }
  });

  var input = $('[data-ev-search]', root);
  if (input) input.addEventListener('input', function () { state.q = input.value; apply(); });
  var form = $('[data-ev-form]', root);
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

  /* ------------------------------------------------------------- timeline
     A chronological strip derived from the same nodes — tiny markers, not a
     second copy of the cards. Clicking one opens the same dialog. */
  var tl = $('[data-ev-timeline]', root);
  if (tl) {
    EVENTS.slice().sort(function (a, b) { return (a.start || 0) - (b.start || 0); }).forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ev-tlitem';
      b.setAttribute('data-ev-open', e.id);
      b.setAttribute('data-when', e.when);
      var mo = document.createElement('span');
      mo.className = 'ev-tlmonth';
      mo.textContent = e.start ? e.start.toLocaleDateString(undefined, { month: 'short' }) : '';
      var nm = document.createElement('span');
      nm.className = 'ev-tlname';
      nm.textContent = e.name;
      var ct = document.createElement('span');
      ct.className = 'ev-tlcity';
      ct.textContent = e.where.split('·')[0].trim();
      b.appendChild(mo); b.appendChild(nm); b.appendChild(ct);
      e.tl = b;
      tl.appendChild(b);
    });
  }

  /* --------------------------------------------------------------- dialog */
  var dlg = $('[data-ev-dialog]', root);
  var current = null;

  function fmtRange(e) {
    if (!e.start) return e.dates;
    var opts = { month: 'short', day: 'numeric' };
    var y = { year: 'numeric' };
    if (e.end && e.end.getTime() !== e.start.getTime()) {
      return e.start.toLocaleDateString(undefined, opts) + ' – ' +
             e.end.toLocaleDateString(undefined, Object.assign({}, opts, y));
    }
    return e.start.toLocaleDateString(undefined, Object.assign({}, opts, y));
  }

  function openEvent(id) {
    var e = BY[id];
    if (!e || !dlg) return;
    current = e;
    var set = function (sel, v) { var el = $(sel, dlg); if (el) el.textContent = v || ''; };
    set('[data-ev-d-type]', e.typeLabel + (e.regionLabel ? ' · ' + e.regionLabel : ''));
    set('[data-ev-d-name]', e.name);
    set('[data-ev-d-dates]', fmtRange(e));
    set('[data-ev-d-venue]', e.venue || '—');
    set('[data-ev-d-where]', e.where.split('·')[0].trim());
    set('[data-ev-d-focus]', e.focus);
    $('[data-ev-d-focuswrap]', dlg).hidden = !e.focus;
    set('[data-ev-d-booth]', e.booth);
    $('[data-ev-d-boothwrap]', dlg).hidden = !e.booth;
    set('[data-ev-d-status]', e.status + (e.confirmed ? '' : ' — the public event is real; the participation status is the separate fact.'));
    $('[data-ev-d-status]', dlg).setAttribute('data-on', String(e.confirmed));
    var site = $('[data-ev-d-site]', dlg);
    if (site) { site.href = e.url || '#'; site.hidden = !e.url; }
    /* the event's own hub page (sections/ed-*) — the primary action when set */
    var hub = $('[data-ev-d-page]', dlg);
    if (hub) { hub.href = e.pageUrl || '#'; hub.hidden = !e.pageUrl; }
    var dlogo = $('[data-ev-d-logo]', dlg);
    if (dlogo) { if (e.logoUrl) dlogo.src = e.logoUrl; dlogo.hidden = !e.logoUrl; }
    $$('[data-ev-pin]', root).forEach(function (p) { p.classList.toggle('is-active', p === e.pin); });
    if (!dlg.open) {
      dlg.showModal();
      if (window.lenis && window.lenis.stop) window.lenis.stop();
      document.documentElement.style.overflow = 'hidden';
    }
  }
  if (dlg) {
    dlg.addEventListener('close', function () {
      if (window.lenis && window.lenis.start) window.lenis.start();
      document.documentElement.style.overflow = '';
      $$('[data-ev-pin]', root).forEach(function (p) { p.classList.remove('is-active'); });
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* .ics — public dates only, all-day, DTEND exclusive per RFC 5545 */
  function icsDate(d) {
    return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
  }
  function downloadICS() {
    var e = current;
    if (!e || !e.start) return;
    var endEx = new Date(e.end.getFullYear(), e.end.getMonth(), e.end.getDate() + 1);
    var lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kiwi Ears//Events//EN',
      'BEGIN:VEVENT',
      'UID:' + e.id + '@kiwiears.com',
      'DTSTAMP:' + icsDate(today) + 'T000000Z',
      'DTSTART;VALUE=DATE:' + icsDate(e.start),
      'DTEND;VALUE=DATE:' + icsDate(endEx),
      'SUMMARY:' + e.name.replace(/[,;\\]/g, function (c) { return '\\' + c; }),
      'LOCATION:' + (e.venue ? e.venue + ', ' : '') + e.where.split('·')[0].trim().replace(/[,;\\]/g, function (c) { return '\\' + c; }),
      'DESCRIPTION:Public event dates. Kiwi Ears participation to be confirmed.' + (e.url ? '\\n' + e.url : ''),
      'END:VEVENT', 'END:VCALENDAR'
    ];
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = e.id + '.ics';
    document.body.appendChild(a);
    a.click();
    setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
  }

  /* ------------------------------------------------- hero: stats + next up */
  var nextEvent = null;
  (function hero() {
    var regions = {}, types = {};
    EVENTS.forEach(function (e) { regions[e.region] = 1; types[e.type] = 1; });
    var map = { events: EVENTS.length, regions: Object.keys(regions).length, formats: Object.keys(types).length };
    $$('[data-ev-stat]').forEach(function (el) {
      var v = map[el.getAttribute('data-ev-stat')];
      if (v != null) el.textContent = v;
    });

    var live = EVENTS.filter(function (e) { return e.when === 'now'; })
      .sort(function (a, b) { return a.end - b.end; })[0];
    var coming = EVENTS.filter(function (e) { return e.when === 'upcoming'; })
      .sort(function (a, b) { return a.start - b.start; })[0];
    nextEvent = live || coming;
    var card = $('[data-ev-next]');
    if (!card || !nextEvent) return;

    var e = nextEvent;
    var set = function (sel, v) { var el = $(sel, card); if (el) el.textContent = v || ''; };
    set('[data-ev-next-type]', e.typeLabel + (e.regionLabel ? ' · ' + e.regionLabel : ''));
    set('[data-ev-next-name]', e.name);
    set('[data-ev-next-where]', e.where);
    set('[data-ev-next-dates]', fmtRange(e));
    var pulse = $('[data-ev-next-state]', card);
    var cdRow = $('[data-ev-next-cd]', card);
    var cdText = $('[data-ev-next-cdwrap]', card);
    function goLive() {
      if (cdRow) cdRow.hidden = true;
      if (cdText) cdText.hidden = false;
      set('[data-ev-next-cdlabel]', 'Status');
      set('[data-ev-next-countdown]', 'Happening now');
      if (pulse) { pulse.textContent = 'Live'; pulse.setAttribute('data-live', '1'); }
    }
    if (live) {
      goLive();
    } else {
      var days = Math.round((e.start - today) / 864e5);
      set('[data-ev-next-countdown]', days === 0 ? 'Today' : days === 1 ? 'Tomorrow' : days + ' days');
      if (pulse) pulse.textContent = e.start.getFullYear() + ' calendar';

      /* the live ticker: counts to the event's first public day (local
         midnight — the same instant the classification flips to "now", so
         the two can never disagree). Under reduced motion a once-a-second
         re-render is exactly the churn being declined, so the plain
         "N days" text above stays instead. */
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (cdRow && !reduce && e.start) {
        var cdq = function (k) { return $('[data-ev-ncd="' + k + '"]', cdRow); };
        var cdD = cdq('d'), cdH = cdq('h'), cdM = cdq('m'), cdS = cdq('s');
        var pad2 = function (n) { return String(n).padStart(2, '0'); };
        var target = e.start.getTime();
        var timer = null;
        var tick = function () {
          var diff = target - Date.now();
          if (diff <= 0) {
            /* doors opened while the page sat open — flip to live */
            if (timer) clearInterval(timer);
            goLive();
            return;
          }
          if (cdD) cdD.textContent = Math.floor(diff / 864e5);
          if (cdH) cdH.textContent = pad2(Math.floor((diff % 864e5) / 36e5));
          if (cdM) cdM.textContent = pad2(Math.floor((diff % 36e5) / 6e4));
          if (cdS) cdS.textContent = pad2(Math.floor((diff % 6e4) / 1000));
        };
        cdText.hidden = true;
        cdRow.hidden = false;
        tick();
        timer = setInterval(tick, 1000);
      }
    }
    card.hidden = false;
  })();

  apply();
})();
